import useThemeStore from "../../store/useThemeStore";

/** Resolves shimmer mode for shimmer-effects-react (`light` | `dark`). */
export function useShimmerMode() {
  const isDark = useThemeStore((state) => state.isDark);
  return isDark ? "dark" : "light";
}
